import React, { useEffect } from 'react';
import AppRender from './AppRender';
import AppLegacy from './AppLegacy';
import 'bootstrap/dist/css/bootstrap.min.css';
const authType = window["APP_SETTINGS"].AUTH_TYPE;
const pathname = window.location.pathname || "";
const forceLegacy = pathname.toLowerCase().includes("/external-form");
const useLegacy = forceLegacy || authType !== "AzureAD";

const App = () => {
  useEffect(() => {
    console.log("App.js - useEffect => State changes detected...");
    if (forceLegacy) {
      console.log("Force legacy due to /external-form path:", pathname);
    } else if (authType === "AzureAD") {
      console.log("AzureAD detected. Starting 'AppRender.js");
    } else {
      console.log("Legacy code detected. Starting 'AppLegacy.js");
    }
  }, [forceLegacy]);

  return (  
    <>
      {!useLegacy && <AppRender />}
      {useLegacy && <AppLegacy />}
    </>
  );    
};

export default App;
